import { ChangeEvent, useEffect, useState } from "react";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import styles from "./addOrgModal.module.scss";
import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { CircularProgress, FormControl, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { useAppSelector, useAppDispatch } from "src/page/store";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { getUserByEmailAction } from "src/page/organisation/organisationSlice";
import { countryCodeData } from "src/types/countryCode";
import { phone } from "phone";
import UserNameInput from "src/components/userNameInput/UserNameInput";
import { checkEmailAvailability, checkUserNameAvailability } from "src/network/graphql/userService";
import { formatInitial, userNameValidation } from "src/utils/utils";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { checkUserDisplayIdExist } from "src/network/graphql/userService";
import { CORPORATE, EMPTY_STRING, INDIVIDUAL, REFERER } from "src/components/constant/constant";

export type orgList = {
  organisationId?: number | string;
  id: number | null;
  name: string;
  referral_code?: string;
  type: string;
  abn: string;
  address: string;
  phone: string;
  website: string;
  facebook: string;
  linkedIn: string;
  instagram: string;
  line1?: string;
  line2?: string;
  city?: string;
  state?: string;
  postcode?: string;
  country?: string;
  referenceName: string;
  referenceRole: string;
  referencePhone: string;
  referenceEmail: string;
  active?: boolean;
  superAdminInitial?: string;
  superAdminFirstName?: string;
  superAdminLastName?: string;
  superAdminDob?: string;
  superAdminEmail?: string;
  superAdminGender?: string;
  superAdminPhone?: string;
  superAdminaddressLine1?: string;
  superAdminaddressLine2?: string;
  superAdminCity?: string;
  superAdminState?: string;
  superAdminPostcode?: string;
  superAdminCountry?: string;
  superAdminUserName?: string;
  existingUserEmail?: string;
};

interface AddOrgModalProps {
  handleClose: () => void;
  onAddOrg: (_input: orgList, _cb?: () => void) => void;
  addUser?: boolean;
  orgInfo?: orgList;
  rootContainrOver?: string;
  closeButton?: boolean;
  orgLoading?: boolean;
  buttonText?: string;
  forParticipant?: boolean;
  Orgtype?: string;
}

export default function AddOrgModal({
  handleClose,
  onAddOrg,
  orgInfo,
  addUser,
  rootContainrOver,
  closeButton = true,
  orgLoading = false,
  buttonText = "Submit",
  forParticipant = false,
  Orgtype
}: AddOrgModalProps) {
  const [input, setInput] = useState({
    id: orgInfo?.id || null,
    name: orgInfo?.name || EMPTY_STRING,
    abn: forParticipant ? "12345678901" : orgInfo?.abn || EMPTY_STRING,
    address: orgInfo?.address || EMPTY_STRING,
    phoneCountryCode: "+61",
    phone: EMPTY_STRING,
    type: orgInfo?.type || EMPTY_STRING,
    referral_code: EMPTY_STRING,
    website: forParticipant ? "no website" : orgInfo?.website || EMPTY_STRING,
    facebook: orgInfo?.facebook || EMPTY_STRING,
    linkedIn: orgInfo?.linkedIn || EMPTY_STRING,
    instagram: orgInfo?.instagram || EMPTY_STRING,
    line1: orgInfo?.line1 || EMPTY_STRING,
    line2: orgInfo?.line2 || EMPTY_STRING,
    city: orgInfo?.city || EMPTY_STRING,
    state: orgInfo?.state || EMPTY_STRING,
    postcode: orgInfo?.postcode || EMPTY_STRING,
    country: orgInfo?.country || "Australia",
    referenceName: orgInfo?.referenceName || EMPTY_STRING,
    referenceRole: orgInfo?.referenceRole || EMPTY_STRING,
    referencePhoneCountryCode: "+61",
    referencePhone: EMPTY_STRING,
    referenceEmail: orgInfo?.referenceEmail || EMPTY_STRING,
    superAdminInitial: "Mr.",
    superAdminFirstName: EMPTY_STRING,
    superAdminLastName: EMPTY_STRING,
    superAdminDob: EMPTY_STRING,
    superAdminEmail: EMPTY_STRING,
    superAdminGender: "Male",
    superAdminPhoneCountryCode: "+61",
    superAdminPhone: EMPTY_STRING,
    superAdminaddressLine1: EMPTY_STRING,
    superAdminaddressLine2: EMPTY_STRING,
    superAdminCity: EMPTY_STRING,
    superAdminState: EMPTY_STRING,
    superAdminPostcode: EMPTY_STRING,
    superAdminCountry: "Australia",
    existingUserEmail: EMPTY_STRING,
    active: orgInfo?.active || true,
    superAdminUserName: EMPTY_STRING
  });
  const [error, setError] = useState({
    name: EMPTY_STRING,
    abn: EMPTY_STRING,
    address: EMPTY_STRING,
    phone: EMPTY_STRING,
    type: EMPTY_STRING,
    referral_code: EMPTY_STRING,
    website: EMPTY_STRING,
    referenceName: EMPTY_STRING,
    referenceRole: EMPTY_STRING,
    referencePhone: EMPTY_STRING,
    referenceEmail: EMPTY_STRING,
    addressLine1: EMPTY_STRING,
    city: EMPTY_STRING,
    state: EMPTY_STRING,
    postcode: EMPTY_STRING,
    country: EMPTY_STRING,
    userFirstName: EMPTY_STRING,
    userLastName: EMPTY_STRING,
    userDob: EMPTY_STRING,
    userEmail: EMPTY_STRING,
    userPhone: EMPTY_STRING,
    useraddressLine1: EMPTY_STRING,
    userCity: EMPTY_STRING,
    userState: EMPTY_STRING,
    userPostcode: EMPTY_STRING,
    userCountry: EMPTY_STRING,
    existingUserEmail: EMPTY_STRING,
    successfull: EMPTY_STRING,
    userName: EMPTY_STRING
  });
  const [currentStep, setCurrentStep] = useState(false);
  const [isSelectExistingUser, setIsSelectExistingUser] = useState<boolean>(false);

  const { addOrgLoading, userData } = useAppSelector((state) => state.organisation);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (forParticipant) {
      setInput((prevInput) => ({
        ...prevInput,
        abn: "12345678901",
        website: "no website"
      }));
    }
  }, []);

  useEffect(() => {
    if (Orgtype) {
      setInput({
        ...input,
        type: Orgtype
      });
    }
  }, [Orgtype]);

  const handleInput = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setInput({ ...input, [e.target.name]: e.target.value });
  };

  const handleCancelClose = () => {
    handleClose();
  };

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  useEffect(() => {
    if (orgInfo?.phone) {
      const phoneData = phone(orgInfo?.phone);

      setInput((prevInput) => ({
        ...prevInput,
        phoneCountryCode: phoneData?.countryCode || "+61",
        phone: phoneData?.phoneNumber?.replace(phoneData.countryCode || EMPTY_STRING, EMPTY_STRING) || EMPTY_STRING
      }));
    }
  }, [orgInfo?.phone]);

  useEffect(() => {
    if (orgInfo?.referencePhone) {
      const referencePhoneData = phone(orgInfo?.referencePhone);

      setInput((prevInput) => ({
        ...prevInput,
        referencePhoneCountryCode: referencePhoneData?.countryCode || "+61",
        referencePhone:
          referencePhoneData?.phoneNumber?.replace(referencePhoneData.countryCode || EMPTY_STRING, EMPTY_STRING) ||
          EMPTY_STRING
      }));
    }
  }, [orgInfo?.referencePhone]);

  const validateInput = async () => {
    if (
      !input.name.trim() ||
      !input.abn.trim() ||
      !input.phone.trim() ||
      !input.type.trim() ||
      !input.website.trim() ||
      !input.referenceName.trim() ||
      !input.referenceRole.trim() ||
      !input.referenceEmail.trim() ||
      !input.referencePhone.trim() ||
      !input.line1.trim() ||
      !input.city.trim() ||
      !input.state.trim() ||
      !input.postcode.trim() ||
      !input.country.trim()
    ) {
      setError({
        ...error,
        name: input.name.trim() ? EMPTY_STRING : "Company name is required",
        abn: input.abn.trim() ? EMPTY_STRING : "Company's Abn is required",
        phone: input.phone.trim()
          ? parsePhoneNumberFromString(input.phoneCountryCode + input.phone)?.isValid()
            ? EMPTY_STRING
            : "Invalid contact number"
          : "Company's phone is required",
        type: input.type.trim() ? EMPTY_STRING : "Company type is required",
        website: input.website.trim() ? EMPTY_STRING : "Company's website is required",
        referenceName: input.referenceName.trim() ? EMPTY_STRING : "Name is required",
        referenceEmail: input.referenceEmail.trim() ? EMPTY_STRING : "Email is required",
        referenceRole: input.referenceRole.trim() ? EMPTY_STRING : "Role is required",
        referencePhone: input.referencePhone.trim()
          ? parsePhoneNumberFromString(input.referencePhoneCountryCode + input.phone)?.isValid()
            ? EMPTY_STRING
            : "Invalid contact number"
          : "Phone number is required",
        addressLine1: input.line1.trim() ? EMPTY_STRING : "Address is required",
        city: input.city.trim() ? EMPTY_STRING : "City is required",
        state: input.state.trim() ? EMPTY_STRING : "State is required",
        postcode: input.postcode.trim() ? EMPTY_STRING : "Postcode is required",
        country: input.country.trim() ? EMPTY_STRING : "Country is required"
      });
      return false;
    }

    if (input.abn.length < 11) {
      setError({
        ...error,
        abn: "ABN number should be equal to 11 digits"
      });
      return false;
    }

    if (!emailRegex.test(input.referenceEmail)) {
      setError({
        ...error,
        referenceEmail: "Invalid email format"
      });
      return false;
    }

    const isReferralValid = await handleReferralCode();
    if (!isReferralValid) {
      return false;
    }

    return true;
  };

  const validUser = async () => {
    const isUserNameAvailable = await checkUserNameAvailability(input.superAdminUserName);

    if (!isUserNameAvailable.data.is_username_available) {
      setError({
        ...error,
        userName: "username already exists"
      });
      return false;
    }
    const isEmailAvailable = await checkEmailAvailability(input.superAdminEmail.toLowerCase());

    if (!isEmailAvailable.data.is_email_available) {
      setError({
        ...error,
        existingUserEmail: "email already exists"
      });
      return false;
    }

    handleReferralCode();

    return true;
  };

  const handleReferralCode = async () => {
    if (input.referral_code.trim()) {
      const response = await checkUserDisplayIdExist(input.referral_code);

      if (!response.data.is_user_display_id_exist) {
        setError({
          ...error,
          referral_code: "Referral ID is Invalid"
        });
        return false;
      } else {
        setError({
          ...error,
          referral_code: EMPTY_STRING
        });
        return true;
      }
    } else {
      setError({
        ...error,
        referral_code: EMPTY_STRING
      });
      return true;
    }
  };

  useEffect(() => {
    if (isSelectExistingUser && userData?.user?.id !== 0) {
      setInput({
        ...input,
        superAdminInitial: formatInitial(userData?.user?.initial),
        superAdminFirstName: userData?.user?.firstName,
        superAdminLastName: userData?.user?.lastName,
        superAdminDob: userData?.user?.dob,
        superAdminEmail: userData?.user?.email,
        superAdminGender: userData.user.gender ?? "Male",
        superAdminPhone: userData?.user?.phoneNumber,
        superAdminaddressLine1: userData?.user?.line1,
        superAdminaddressLine2: userData?.user?.line2,
        superAdminCity: userData?.user?.city,
        superAdminState: userData?.user?.state,
        superAdminPostcode: userData?.user?.zipcode,
        superAdminCountry: userData?.user?.country ?? "Australia"
      });
      setError({
        ...error,
        existingUserEmail: EMPTY_STRING,
        successfull: "Email found"
      });
    }
  }, [isSelectExistingUser, userData]);

  const handleAddOrg = () => {
    if (addUser) {
      if (isSelectExistingUser) {
        if (!input?.existingUserEmail.trim()) {
          setError({
            ...error,
            existingUserEmail: "Email is required"
          });
          return;
        }

        if (!emailRegex.test(input?.existingUserEmail)) {
          setError({
            ...error,
            existingUserEmail: "Invalid email format"
          });
          return;
        }
      } else {
        if (
          !input.superAdminFirstName.trim() ||
          !input.superAdminLastName.trim() ||
          !input.superAdminDob.trim() ||
          !input.superAdminEmail.trim() ||
          !input.superAdminCity.trim() ||
          !input.superAdminState.trim() ||
          !input.superAdminPostcode.trim() ||
          !input.superAdminCountry.trim() ||
          !input.superAdminPhone.trim() ||
          !input.superAdminUserName.trim()
        ) {
          setError({
            ...error,
            userFirstName: input.superAdminFirstName.trim() ? EMPTY_STRING : "First name is required",
            userLastName: input.superAdminLastName.trim() ? EMPTY_STRING : "Last name is required",
            userDob: input.superAdminDob.trim() ? EMPTY_STRING : "DOB is required",
            userEmail: input.superAdminEmail.trim() ? EMPTY_STRING : "Email is required",
            userPhone: input.superAdminPhone.trim() ? EMPTY_STRING : "Phone is required",
            useraddressLine1: input.superAdminaddressLine1.trim() ? EMPTY_STRING : "address is required",
            userCity: input.superAdminCity.trim() ? EMPTY_STRING : "city is required",
            userState: input.superAdminState.trim() ? EMPTY_STRING : "state is required",
            userPostcode: input.superAdminPostcode.trim() ? EMPTY_STRING : "postcode is required",
            userCountry: input.superAdminCountry.trim() ? EMPTY_STRING : "country is required",

            userName: input.superAdminUserName.trim()
              ? userNameValidation(input.superAdminUserName)
                ? error.userName
                : EMPTY_STRING
              : "Username is required"
          });
          return;
        }

        if (!emailRegex.test(input.superAdminEmail)) {
          setError({
            ...error,
            userEmail: "Invalid email format"
          });
          return;
        }

        if (!validUser()) {
          return;
        }
      }
    } else {
      if (!validateInput()) {
        return;
      }
    }

    onAddOrg(
      {
        ...input,
        organisationId: orgInfo?.organisationId,
        phone: input.phoneCountryCode + input.phone,
        referencePhone: input.referencePhoneCountryCode + input.referencePhone,
        referenceEmail: input.referenceEmail.toLowerCase(),
        superAdminEmail: input.superAdminEmail.toLowerCase(),
        superAdminPhone:
          isSelectExistingUser && userData?.user?.id !== 0
            ? input.superAdminPhone
            : input.superAdminPhoneCountryCode + input.superAdminPhone
      },
      () => {
        setInput({
          id: null,
          name: EMPTY_STRING,
          abn: EMPTY_STRING,
          address: EMPTY_STRING,
          phoneCountryCode: EMPTY_STRING,
          phone: EMPTY_STRING,
          type: EMPTY_STRING,
          referral_code: EMPTY_STRING,
          website: EMPTY_STRING,
          facebook: EMPTY_STRING,
          linkedIn: EMPTY_STRING,
          instagram: EMPTY_STRING,
          line1: EMPTY_STRING,
          line2: EMPTY_STRING,
          city: EMPTY_STRING,
          state: EMPTY_STRING,
          postcode: EMPTY_STRING,
          country: EMPTY_STRING,
          referenceName: EMPTY_STRING,
          referenceRole: EMPTY_STRING,
          referencePhone: EMPTY_STRING,
          referencePhoneCountryCode: EMPTY_STRING,
          referenceEmail: EMPTY_STRING,
          superAdminInitial: EMPTY_STRING,
          superAdminFirstName: EMPTY_STRING,
          superAdminLastName: EMPTY_STRING,
          superAdminDob: EMPTY_STRING,
          superAdminEmail: EMPTY_STRING,
          superAdminGender: EMPTY_STRING,
          superAdminPhoneCountryCode: EMPTY_STRING,
          superAdminPhone: EMPTY_STRING,
          superAdminaddressLine1: EMPTY_STRING,
          superAdminaddressLine2: EMPTY_STRING,
          superAdminCity: EMPTY_STRING,
          superAdminState: EMPTY_STRING,
          superAdminPostcode: EMPTY_STRING,
          superAdminCountry: EMPTY_STRING,
          existingUserEmail: EMPTY_STRING,
          active: true,
          superAdminUserName: EMPTY_STRING
        });
        setError({
          ...error,
          userFirstName: EMPTY_STRING,
          userLastName: EMPTY_STRING,
          userDob: EMPTY_STRING,
          userEmail: EMPTY_STRING,
          userPhone: EMPTY_STRING,
          useraddressLine1: EMPTY_STRING,
          userCity: EMPTY_STRING,
          userState: EMPTY_STRING,
          userPostcode: EMPTY_STRING,
          userCountry: EMPTY_STRING,
          existingUserEmail: EMPTY_STRING
        });
        handleClose();
      }
    );
  };

  const handleNext = async () => {
    const isValid = await validateInput();
    if (!isValid) return;
    setCurrentStep(true);

    setError({
      ...error,
      name: EMPTY_STRING,
      abn: EMPTY_STRING,
      address: EMPTY_STRING,
      referral_code: EMPTY_STRING,
      phone: EMPTY_STRING,
      type: EMPTY_STRING,
      website: EMPTY_STRING,
      referenceName: EMPTY_STRING,
      referenceRole: EMPTY_STRING,
      referencePhone: EMPTY_STRING,
      referenceEmail: EMPTY_STRING,
      addressLine1: EMPTY_STRING,
      city: EMPTY_STRING,
      state: EMPTY_STRING,
      postcode: EMPTY_STRING,
      country: EMPTY_STRING
    });
  };

  const addNewUser = () => {
    setIsSelectExistingUser(false);
    setInput({
      ...input,
      superAdminFirstName: EMPTY_STRING,
      superAdminLastName: EMPTY_STRING,
      superAdminDob: EMPTY_STRING,
      superAdminEmail: EMPTY_STRING,
      superAdminPhone: EMPTY_STRING,
      superAdminaddressLine1: EMPTY_STRING,
      superAdminCity: EMPTY_STRING,
      superAdminState: EMPTY_STRING,
      superAdminPostcode: EMPTY_STRING,
      superAdminCountry: EMPTY_STRING
    });
  };

  const addExistingUser = () => {
    setIsSelectExistingUser(true);
    setInput({
      ...input,
      superAdminFirstName: EMPTY_STRING,
      superAdminLastName: EMPTY_STRING,
      superAdminDob: EMPTY_STRING,
      superAdminEmail: EMPTY_STRING,
      superAdminPhone: EMPTY_STRING,
      superAdminaddressLine1: EMPTY_STRING,
      superAdminCity: EMPTY_STRING,
      superAdminState: EMPTY_STRING,
      superAdminPostcode: EMPTY_STRING,
      superAdminCountry: EMPTY_STRING
    });
  };

  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    setInput({
      ...input,
      [event.target.name]: event.target.value
    });
  };

  const handleFetchUser = () => {
    if (!emailRegex.test(input?.existingUserEmail)) {
      setError({ ...error, existingUserEmail: "Invalid Email", successfull: EMPTY_STRING });
      return;
    }
    dispatch(getUserByEmailAction(input?.existingUserEmail.toLowerCase()));
  };

  const handleCountryCodeChange = (event: SelectChangeEvent<string>) => {
    const { name, value } = event.target;

    setInput({ ...input, [name]: value });
  };

  const handleOrgContactBlur = () => {
    const phoneNumber = parsePhoneNumberFromString(input.phoneCountryCode + input.phone);

    if (!phoneNumber || !phoneNumber.isValid()) {
      setError({
        ...error,
        phone: "Invalid contact number"
      });
    } else {
      setError({
        ...error,
        phone: EMPTY_STRING
      });
    }
  };

  const handleReferenceContactBlur = () => {
    const phoneNumber = parsePhoneNumberFromString(input.referencePhoneCountryCode + input.referencePhone);

    if (!phoneNumber || !phoneNumber.isValid()) {
      setError({
        ...error,
        referencePhone: "Invalid contact number"
      });
    } else {
      setError({
        ...error,
        referencePhone: EMPTY_STRING
      });
    }
  };

  return (
    <div className={` ${styles.rootContainer} ${rootContainrOver}`}>
      <main className={styles.modalTop}>
        <form>
          <div className={styles.close}>
            <h5>{!currentStep ? "General Company Info" : "Add User"}</h5>
            {closeButton && (
              <button onClick={handleCancelClose} aria-label="close">
                <CloseIcon onClick={handleCancelClose} />
              </button>
            )}
          </div>
          {orgLoading ? (
            <div className={styles.progress}>
              <CircularProgress sx={{ color: "#0f172a" }} />
            </div>
          ) : (
            <>
              {EMPTY_STRING}
              {!currentStep ? (
                <>
                  <div className={styles.generalCompany}>
                    <div className={styles.companyName}>
                      <label htmlFor="name">{forParticipant ? "Participant Name" : "Company Name"}:</label>
                      <div className={styles.inputWerror}>
                        <input
                          id="name"
                          type="text"
                          placeholder="Enter Text Here"
                          value={input.name}
                          name="name"
                          onChange={handleInput}
                        />
                        {error.name && (
                          <div className={styles.error}>
                            <ErrorOutlineIcon className={styles.errIcon} />
                            {error.name}
                          </div>
                        )}
                      </div>
                    </div>
                    {!forParticipant && (
                      <div className={styles.abnName}>
                        <label htmlFor="abn">ABN :</label>
                        <div className={styles.inputWerror}>
                          <input
                            id="abn"
                            type="text"
                            placeholder="Enter Text Here"
                            maxLength={11}
                            value={input.abn}
                            name="abn"
                            onChange={handleInput}
                          />
                          {error.abn && (
                            <div className={styles.error}>
                              <ErrorOutlineIcon className={styles.errIcon} />
                              {error.abn}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    <div className={styles.mobile}>
                      <label htmlFor="orgcontact">Contact Phone :</label>
                      <div className={styles.inputWerror}>
                        <div className={styles.mobileSelect}>
                          <Select
                            value={input.phoneCountryCode || "+61"}
                            onChange={handleCountryCodeChange}
                            displayEmpty
                            name="phoneCountryCode"
                            className={styles.countryCodeSelect}
                            sx={{ height: "50px" }}
                          >
                            {countryCodeData.map((country) => (
                              <MenuItem key={country.code} value={country.code}>
                                {country.code}
                              </MenuItem>
                            ))}
                          </Select>
                          <input
                            id="orgcontact"
                            type="text"
                            placeholder="Enter Text Here"
                            value={input.phone}
                            name="phone"
                            onChange={handleInput}
                            onBlur={handleOrgContactBlur}
                          />
                        </div>
                        {error.phone && (
                          <div className={styles.error}>
                            <ErrorOutlineIcon className={styles.errIcon} />
                            {error.phone}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className={styles.mobile}>
                      <label htmlFor="type">Type :</label>
                      <div className={styles.inputWerror}>
                        <div className={styles.mobileSelect}>
                          <FormControl sx={{ m: 1, margin: 0, width: "100%" }}>
                            <Select
                              id="type"
                              value={input.type}
                              onChange={(e) => {
                                if (e.target.value === "type") {
                                  setInput({
                                    ...input,
                                    type: EMPTY_STRING
                                  });
                                } else {
                                  setInput({
                                    ...input,
                                    type: e.target.value
                                  });
                                }
                              }}
                              displayEmpty
                              inputProps={{ "aria-label": "Without label" }}
                              sx={{
                                height: 50,
                                border: "#e0e2e7",
                                borderRadius: "8px",
                                color: {
                                  CORPORATE: EMPTY_STRING,
                                  INDIVIDUAL: EMPTY_STRING,
                                  EMPTY_STRING: "grey",
                                  default: "grey"
                                }[input.type ?? "default"]
                              }}
                            >
                              <MenuItem value={EMPTY_STRING} sx={{ color: "grey" }}>
                                Type
                              </MenuItem>
                              <MenuItem value={CORPORATE}>Corporate</MenuItem>
                              <MenuItem value={INDIVIDUAL}>Individual</MenuItem>
                              <MenuItem value={REFERER}>Referer</MenuItem>
                            </Select>
                          </FormControl>
                        </div>
                        {error.type && (
                          <div className={styles.error}>
                            <ErrorOutlineIcon className={styles.errIcon} />
                            {error.type}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className={styles.abnName}>
                      <label htmlFor="referral">Referral Code :</label>
                      <div className={styles.inputWerror}>
                        <input
                          id="referral_code"
                          type="text"
                          placeholder="Enter Text Here"
                          value={input.referral_code.toUpperCase()}
                          name="referral_code"
                          onChange={handleInput}
                          onBlur={handleReferralCode}
                        />
                        {error.referral_code && (
                          <div className={styles.error}>
                            <ErrorOutlineIcon className={styles.errIcon} />
                            {error.referral_code}
                          </div>
                        )}
                      </div>
                    </div>
                    {!forParticipant && (
                      <div className={styles.website}>
                        <label htmlFor="website">Website :</label>
                        <div className={styles.inputWerror}>
                          <input
                            id="website"
                            type="text"
                            placeholder="Enter Text Here"
                            value={input.website}
                            name="website"
                            onChange={handleInput}
                          />
                          {error.website && (
                            <div className={styles.error}>
                              <ErrorOutlineIcon className={styles.errIcon} />
                              {error.website}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    <div className={styles.facebook}>
                      <label htmlFor="facebook">Facebook :</label>
                      <input
                        id="facebook"
                        type="text"
                        placeholder="Enter Text Here"
                        value={input.facebook}
                        name="facebook"
                        onChange={handleInput}
                      />
                    </div>
                    <div className={styles.instagram}>
                      <label htmlFor="instagram">Instagram :</label>
                      <input
                        id="instagram"
                        type="text"
                        placeholder="Enter Text Here"
                        value={input.instagram}
                        name="instagram"
                        onChange={handleInput}
                      />
                    </div>

                    <div className={styles.linkedIn}>
                      <label htmlFor="linkedIn">LinkedIn :</label>
                      <input
                        id="linkedIn"
                        type="text"
                        placeholder="Enter Text Here"
                        value={input.linkedIn}
                        name="linkedIn"
                        onChange={handleInput}
                      />
                    </div>
                  </div>
                  <div className={styles.close}>
                    <h5>Company Address</h5>
                  </div>
                  <div className={styles.companyAddress}>
                    <div className={styles.addressLine1}>
                      <label htmlFor="addressline1">Line 1 :</label>
                      <div className={styles.inputWerror}>
                        <input
                          id="addressline1"
                          type="text"
                          placeholder="Enter Text Here"
                          value={input.line1}
                          name="line1"
                          onChange={handleInput}
                        />
                        {error.addressLine1 && (
                          <div className={styles.error}>
                            <ErrorOutlineIcon className={styles.errIcon} />
                            {error.addressLine1}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className={styles.addressLine2}>
                      <label htmlFor="addressline2">Line 2 :</label>
                      <input
                        id="addressline2"
                        type="text"
                        placeholder="Enter Text Here"
                        value={input.line2}
                        name="line2"
                        onChange={handleInput}
                      />
                    </div>
                    <div className={styles.city}>
                      <label htmlFor="city">City :</label>
                      <div className={styles.inputWerror}>
                        <input
                          id="city"
                          type="text"
                          placeholder="Enter Text Here"
                          value={input.city}
                          name="city"
                          onChange={handleInput}
                        />
                        {error.city && (
                          <div className={styles.error}>
                            <ErrorOutlineIcon className={styles.errIcon} />
                            {error.city}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className={styles.state}>
                      <label htmlFor="state">State :</label>
                      <div className={styles.inputWerror}>
                        <input
                          id="state"
                          type="text"
                          placeholder="Enter Text Here"
                          value={input.state}
                          name="state"
                          onChange={handleInput}
                        />
                        {error.state && (
                          <div className={styles.error}>
                            <ErrorOutlineIcon className={styles.errIcon} />
                            {error.state}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className={styles.postcode}>
                      <label htmlFor="postcode">Postcode :</label>
                      <div className={styles.inputWerror}>
                        <input
                          id="postcode"
                          type="text"
                          placeholder="Enter Text Here"
                          value={input.postcode}
                          name="postcode"
                          onChange={handleInput}
                        />
                        {error.postcode && (
                          <div className={styles.error}>
                            <ErrorOutlineIcon className={styles.errIcon} />
                            {error.postcode}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className={styles.country}>
                      <label htmlFor="country">Country :</label>
                      <div className={styles.inputWerror}>
                        <input
                          id="country"
                          type="text"
                          placeholder="Enter Text Here"
                          value={input.country}
                          name="country"
                          onChange={handleInput}
                        />
                        {error.country && (
                          <div className={styles.error}>
                            <ErrorOutlineIcon className={styles.errIcon} />
                            {error.country}
                          </div>
                        )}
                      </div>
                    </div>
                    {/* </div> */}
                  </div>
                  <div className={styles.close}>
                    <h5>Main Contact</h5>
                  </div>
                  <div className={styles.mainContact}>
                    <div className={styles.name}>
                      <label htmlFor="referencename">Name :</label>
                      <div className={styles.inputWerror}>
                        <input
                          id="referencename"
                          type="text"
                          placeholder="Enter Text Here"
                          value={input.referenceName}
                          name="referenceName"
                          onChange={handleInput}
                        />
                        {error.referenceName && (
                          <div className={styles.error}>
                            <ErrorOutlineIcon className={styles.errIcon} />
                            {error.referenceName}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className={styles.role}>
                      <label htmlFor="role">Role :</label>
                      <div className={styles.inputWerror}>
                        <input
                          id="role"
                          type="text"
                          placeholder="Enter Text Here"
                          value={input.referenceRole}
                          name="referenceRole"
                          onChange={handleInput}
                        />
                        {error.referenceRole && (
                          <div className={styles.error}>
                            <ErrorOutlineIcon className={styles.errIcon} />
                            {error.referenceRole}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className={styles.phone}>
                      <label htmlFor="referencephone">Phone :</label>
                      <div className={styles.inputWerror}>
                        <div className={styles.mobileSelect}>
                          <Select
                            value={input.referencePhoneCountryCode || "+61"}
                            onChange={handleCountryCodeChange}
                            displayEmpty
                            name="referencePhoneCountryCode"
                            className={styles.countryCodeSelect}
                            sx={{ height: "50px" }}
                          >
                            {countryCodeData.map((country) => (
                              <MenuItem key={country.code} value={country.code}>
                                {country.code}
                              </MenuItem>
                            ))}
                          </Select>
                          <input
                            id="referencephone"
                            type="text"
                            placeholder="Enter Text Here"
                            value={input.referencePhone}
                            name="referencePhone"
                            onChange={handleInput}
                            onBlur={handleReferenceContactBlur}
                          />
                        </div>
                        {error.referencePhone && (
                          <div className={styles.error}>
                            <ErrorOutlineIcon className={styles.errIcon} />
                            {error.referencePhone}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className={styles.email}>
                      <label htmlFor="refrenceemail">Email :</label>
                      <div className={styles.inputWerror}>
                        <input
                          id="refrenceemail"
                          type="text"
                          placeholder="Enter Text Here"
                          value={input.referenceEmail}
                          name="referenceEmail"
                          onChange={handleInput}
                        />
                        {error.referenceEmail && (
                          <div className={styles.error}>
                            <ErrorOutlineIcon className={styles.errIcon} />
                            {error.referenceEmail}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <div className={styles.UserDetail}>
                  <div className={styles.radioOption}>
                    <div>
                      <label htmlFor="newuser">
                        <input
                          id="newuser"
                          type="radio"
                          name="userType"
                          value="new"
                          checked={!isSelectExistingUser}
                          onChange={addNewUser}
                        />
                        Add New User
                      </label>
                    </div>
                    <div>
                      <label htmlFor="existinguser">
                        <input
                          id="exisitinguser"
                          type="radio"
                          name="userType"
                          value="existing"
                          checked={isSelectExistingUser}
                          onChange={addExistingUser}
                        />
                        Add Existing User
                      </label>
                    </div>
                  </div>
                  {isSelectExistingUser ? (
                    <div className={styles.existingUser}>
                      <div className={styles.email}>
                        <label htmlFor="useremail">User Email</label>
                        <div className={styles.existingUserEmail}>
                          <input
                            id="useremail"
                            type="email"
                            placeholder="example@gmail.com"
                            value={input.existingUserEmail}
                            name="existingUserEmail"
                            onChange={handleInput}
                          />
                          <Button className={styles.getUser} variant="contained" onClick={handleFetchUser}>
                            Get User
                          </Button>
                        </div>
                        {error.existingUserEmail && (
                          <div className={styles.error}>
                            <ErrorOutlineIcon className={styles.errIcon} />
                            {error.existingUserEmail}
                          </div>
                        )}
                        {error.successfull && (
                          <div className={styles.success}>
                            <CheckCircleOutlineIcon className={styles.successIcon} />
                            {error.successfull}
                          </div>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className={styles.newUser}>
                      <h3>Personal Information</h3>
                      <div className={styles.name}>
                        <div className={styles.initial}>
                          <FormControl sx={{ m: 1, margin: 0 }}>
                            <Select
                              value={input.superAdminInitial}
                              onChange={handleSelectChange}
                              displayEmpty
                              inputProps={{ "aria-label": "Without label", name: "superAdminInitial" }}
                              sx={{
                                height: 49
                              }}
                            >
                              <MenuItem value="Mr.">Mr.</MenuItem>
                              <MenuItem value="Ms.">Ms.</MenuItem>
                              <MenuItem value="Mx.">Mx.</MenuItem>
                              <MenuItem value="Mrs.">Mrs.</MenuItem>
                              <MenuItem value="Miss.">Miss.</MenuItem>
                            </Select>
                          </FormControl>
                        </div>
                        <div className={styles.Fname}>
                          <label htmlFor="userfirstname">First Name</label>
                          <input
                            id="userfirstname"
                            type="text"
                            placeholder="Enter Text Here"
                            value={input.superAdminFirstName}
                            name="superAdminFirstName"
                            onChange={handleInput}
                          />
                          {error.userFirstName && (
                            <div className={styles.error}>
                              <ErrorOutlineIcon className={styles.errIcon} />
                              {error.userFirstName}
                            </div>
                          )}
                        </div>
                        <div className={styles.Lname}>
                          <label htmlFor="userlastname">Last Name</label>
                          <input
                            id="userlastname"
                            type="text"
                            placeholder="Enter Text Here"
                            value={input.superAdminLastName}
                            name="superAdminLastName"
                            onChange={handleInput}
                          />
                          {error.userLastName && (
                            <div className={styles.error}>
                              <ErrorOutlineIcon className={styles.errIcon} />
                              {error.userLastName}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className={styles.userrow}>
                        <div className={styles.dob}>
                          <label htmlFor="dob">DOB:</label>
                          <input
                            id="dob"
                            type="date"
                            value={input.superAdminDob}
                            name="superAdminDob"
                            onChange={handleInput}
                          />
                          {error.userDob && (
                            <div className={styles.error}>
                              <ErrorOutlineIcon className={styles.errIcon} />
                              {error.userDob}
                            </div>
                          )}
                        </div>
                        <div className={styles.email}>
                          <label htmlFor="superadminemail">User Email</label>
                          <input
                            id="superadminemail"
                            type="email"
                            placeholder="example@gmail.com"
                            value={input.superAdminEmail}
                            name="superAdminEmail"
                            onChange={handleInput}
                          />
                          {error.userEmail && (
                            <div className={styles.error}>
                              <ErrorOutlineIcon className={styles.errIcon} />
                              {error.userEmail}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className={styles.userrow}>
                        <div className={styles.gender}>
                          <label htmlFor="gender">Gender:</label>
                          <FormControl sx={{ m: 1, margin: 0 }}>
                            <Select
                              id="gender"
                              aria-label="Select Gender"
                              value={input.superAdminGender}
                              onChange={handleSelectChange}
                              displayEmpty
                              inputProps={{ "aria-label": "Without label", name: "superAdminGender" }}
                              sx={{
                                height: 49
                              }}
                            >
                              <MenuItem value="male">Male</MenuItem>
                              <MenuItem value="female">Female</MenuItem>
                              <MenuItem value="unknown">Non Binary</MenuItem>
                            </Select>
                          </FormControl>
                        </div>
                        <div className={styles.phone}>
                          <label htmlFor="superadmincontact">Contact</label>
                          <div className={styles.mobileSelect}>
                            <Select
                              value={input.superAdminPhoneCountryCode || "+61"}
                              onChange={handleCountryCodeChange}
                              displayEmpty
                              name="superAdminPhoneCountryCode"
                              className={styles.countryCodeSelect}
                              sx={{ height: "50px" }}
                            >
                              {countryCodeData.map((country) => (
                                <MenuItem key={country.code} value={country.code}>
                                  {country.code}
                                </MenuItem>
                              ))}
                            </Select>
                            <input
                              id="superadmincontact"
                              type="text"
                              placeholder="4745625522"
                              value={input.superAdminPhone}
                              name="superAdminPhone"
                              onChange={handleInput}
                            />
                          </div>
                          {error.userPhone && (
                            <div className={styles.error}>
                              <ErrorOutlineIcon className={styles.errIcon} />
                              {error.userPhone}
                            </div>
                          )}
                        </div>
                      </div>
                      <UserNameInput
                        value={input.superAdminUserName}
                        setValue={(value) => {
                          setInput((prevValue) => ({
                            ...prevValue,
                            superAdminUserName: value
                          }));
                        }}
                        error={error.userName}
                        setError={(value: string) =>
                          setError({
                            ...error,
                            userName: value
                          })
                        }
                      />{" "}
                      <h3>Address</h3>
                      <div className={styles.userrow}>
                        <div className={styles.addressLine1}>
                          <label htmlFor="superadminaddressline1">Line 1 :</label>
                          <div className={styles.inputWerror}>
                            <input
                              id="superadminaddressline1"
                              type="text"
                              placeholder="Enter Text Here"
                              value={input.superAdminaddressLine1}
                              name="superAdminaddressLine1"
                              onChange={handleInput}
                            />
                            {error.useraddressLine1 && (
                              <div className={styles.error}>
                                <ErrorOutlineIcon className={styles.errIcon} />
                                {error.useraddressLine1}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className={styles.addressLine2}>
                          <label htmlFor="superadminaddressline2">Line 2 :</label>
                          <input
                            id="superadminaddressline2"
                            type="text"
                            placeholder="Enter Text Here"
                            value={input.superAdminaddressLine2}
                            name="superAdminaddressLine2"
                            onChange={handleInput}
                          />
                        </div>
                      </div>
                      {addOrgLoading ? (
                        <div></div>
                      ) : (
                        <>
                          <div className={styles.userrow}>
                            <div className={styles.city}>
                              <label htmlFor="superadmincity">City :</label>
                              <div className={styles.inputWerror}>
                                <input
                                  id="superadmincity"
                                  type="text"
                                  placeholder="Enter Text Here"
                                  value={input.superAdminCity}
                                  name="superAdminCity"
                                  onChange={handleInput}
                                />
                                {error.userCity && (
                                  <div className={styles.error}>
                                    <ErrorOutlineIcon className={styles.errIcon} />
                                    {error.userCity}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className={styles.state}>
                              <label htmlFor="superadminstate">State :</label>
                              <div className={styles.inputWerror}>
                                <input
                                  id="superadminstate"
                                  type="text"
                                  placeholder="Enter Text Here"
                                  value={input.superAdminState}
                                  name="superAdminState"
                                  onChange={handleInput}
                                />
                                {error.userState && (
                                  <div className={styles.error}>
                                    <ErrorOutlineIcon className={styles.errIcon} />
                                    {error.userState}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className={styles.userrow}>
                            <div className={styles.postcode}>
                              <label htmlFor="superadminpostcode">Postcode :</label>
                              <div className={styles.inputWerror}>
                                <input
                                  id="superadminpostcode"
                                  type="text"
                                  placeholder="Enter Text Here"
                                  value={input.superAdminPostcode}
                                  name="superAdminPostcode"
                                  onChange={handleInput}
                                />
                                {error.userPostcode && (
                                  <div className={styles.error}>
                                    <ErrorOutlineIcon className={styles.errIcon} />
                                    {error.userPostcode}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className={styles.country}>
                              <label htmlFor="superadmincountry">Country :</label>
                              <div className={styles.inputWerror}>
                                <input
                                  id="superadmincountry"
                                  type="text"
                                  placeholder="Enter Text Here"
                                  value={input.superAdminCountry}
                                  name="superAdminCountry"
                                  onChange={handleInput}
                                />
                                {error.userCountry && (
                                  <div className={styles.error}>
                                    <ErrorOutlineIcon className={styles.errIcon} />
                                    {error.userCountry}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </div>
              )}
            </>
          )}
        </form>
      </main>
      <footer className={styles.modalBottom}>
        <div className={styles.referModalBtn}>
          <Stack spacing={2} direction="row">
            {addUser ? (
              <>
                {EMPTY_STRING}
                {!currentStep ? (
                  <Button className={styles.sendBtn} variant="contained" onClick={handleNext}>
                    Next
                  </Button>
                ) : (
                  <>
                    <Button
                      className={styles.sendBtn}
                      variant="contained"
                      onClick={() => {
                        setCurrentStep(false);
                      }}
                    >
                      Back
                    </Button>
                    <Button className={styles.sendBtn} variant="contained" onClick={handleAddOrg}>
                      Submit
                    </Button>
                  </>
                )}
              </>
            ) : (
              <Button className={styles.sendBtn} variant="contained" onClick={handleAddOrg}>
                {buttonText}
              </Button>
            )}
          </Stack>
        </div>
      </footer>
    </div>
  );
}
